import React, { useRef } from "react";
import PropTypes from "prop-types";
import "./DropFileInput.css";

const DropFileInput = (props) => {
  const wrapperRef = useRef(null);

  const onDragEnter = () => wrapperRef.current.classList.add("dragover");

  const onDragLeave = () => wrapperRef.current.classList.remove("dragover");

  const onDrop = () => wrapperRef.current.classList.remove("dragover");

  const onFileDrop = (e) => {
    const newFile = e.target.files[0];
    if (newFile) {
      props.onFileChange(newFile);
    }
  };

  return (
    <>
      <div
        ref={wrapperRef}
        className="drop-file-input"
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
      >
        <div className="drop-file-input__label">
          <div className="upload-icon">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.35 10.04A7.49 7.49 0 0 0 12 4C9.11 4 6.6 5.64 5.35 8.04A5.994 5.994 0 0 0 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
            </svg>
          </div>
          <p className="upload-main-text">Drop files here or <span>browse</span></p>
          <p className="upload-sub-text">{props.acceptFileTypes || ".jpg, .jpeg, .png, .webp, .mp4"}</p>
        </div>
        {props.isrequired ? (
          <input
            type="file"
            onChange={onFileDrop}
            accept={
              props.acceptFileTypes
                ? props.acceptFileTypes
                : ".jpg, .jpeg, .gif, .png, .webp, .heic, .mp4, .mkv, .mov"
            }
            required={props.filesUrls?.length > 0 ? false : true}
            disabled={props.disabled}
          />
        ) : (
          <input
            type="file"
            onChange={onFileDrop}
            accept={
              props.acceptFileTypes
                ? props.acceptFileTypes
                : ".jpg, .jpeg, .gif, .png, .webp, .heic, .mp4, .mkv, .mov"
            }
            required={false}
            disabled={props.disabled}
          />
        )}
      </div>
    </>
  );
};

DropFileInput.propTypes = {
  onFileChange: PropTypes.func,
};

export default DropFileInput;
